"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotificationComponent = void 0;
var notification_component_1 = require("./notification-component");
Object.defineProperty(exports, "NotificationComponent", { enumerable: true, get: function () { return notification_component_1.NotificationComponent; } });
